
export const GET_DASHBOARD = 'GET_DASHBOARD';
export const GET_DASHBOARD_SUCCESS = 'GET_DASHBOARD_SUCCESS';
export const SHOW_DASHBOARD_LOADING = 'SHOW_DASHBOARD_LOADING'
export const GET_DASHBOARD_ERROR = 'GET_DASHBOARD_ERROR'